<template>
  <div v-if="body_show">
    <div v-html="topimg" class="img"></div>
      <div class="difficu-card" v-if="list.length>0" v-for="(item,index) in list" :key="index">
        <h2>{{item.taskname}}</h2>
        <p v-for="(ite,idxs) in item.glossary" :key="idxs"><span>{{ite.word_name}}</span>{{ite.word_explain}}</p>
      </div>
  </div>
</template>
<script>
import {
  glossary
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        topimg: "",
        list: [],
      }
    },
    methods: {
      pullData() {
        glossary({
            course_id: this.$route.query.cid,
            project_id: this.$route.query.cpid
          })
          .then((data) => {
            this.body_show = true;
            this.topimg = data.topimg;
            this.list = data.data;
            // 神策统计--难词表
            sensors.track('projectWorkbox', {
              course_id: this.$route.query.cid,
              course_name: data.coursename,
              project_id: this.$route.query.cpid,
              project_name: data.projectname,
              workbox_type: "难词表",
              workbox_name: "难词表",
            });
          })

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.difficu-card {
    padding: changeRem(.6)+px changeRem(.6)+px changeRem(.8)+px changeRem(.6)+px;
    margin-top: changeRem(.4)+px;
    background-color: #FFFFFF;
     h2 {
    font-weight: bold;
    font-size: changeRem(.68)+px;
    color: #333333;
    padding-bottom: changeRem(.6)+px;
    margin-bottom: changeRem(.6)+px;
    text-align: left;
    border-bottom: 1px solid #CCCCCC;
}
p {
    font-size: changeRem(.56)+px;
    color: #666666;
    line-height: changeRem(.82)+px;
    text-align: left;
    margin-bottom: changeRem(.54)+px;
    span {
    color: #EB5032;
    font-size: changeRem(.56)+px;
}
p:last-child {
    margin-bottom: 0;
}
}
}
</style>
<style>
img {
  width: 100%
}
</style>
